import {
  beSmsMessageGetMessages,
  beSmsMessageGetSMSDetails
} from 'Api/beSmsMessageApi'
import memo from 'Helpers/memo'
import { storeGet, STORE_KEY_ID_LIST } from 'mailup-react-helpers'

export const SMS_SELECT_MAX_ITEMS = 700

const makeSmsItem = ({ Id, Subject }) => ({
  label: `${Id} - ${Subject}`,
  value: Id
})

async function fetchSmsList(searchString) {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const { Items, TotalItems } = await beSmsMessageGetMessages(
    idList,
    {
      pageNumber: 1,
      pageSize: SMS_SELECT_MAX_ITEMS,
      orderBy: 'Id',
      orderDescending: false
    },
    {
      Subject: searchString
    }
  )

  return {
    items: Items.map((o) => makeSmsItem(o)),
    totalItems: TotalItems
  }
}

export const getMemoSmsMessagesList = memo(fetchSmsList)

export async function fetchMessageDetailsById(idMessage) {
  const result = await beSmsMessageGetSMSDetails(idMessage)
  return result ? makeSmsItem(result) : null
}
